<mat-drawer-container [hasBackdrop]="tabletQuery.matches" class="page-height">
  <mat-drawer
    #drawer
    [mode]="tabletQuery.matches ? 'over' : 'side'"
    [position]="'end'"
    [opened]="!tabletQuery.matches"
    [disableClose]="!tabletQuery.matches"
    >
    <!-- Actions in sidenav -->
    <div class="h-100">
      <div>
        @if (viewMode === 'links') {
        <div class="p-2">
          <mat-form-field color="primary" appearance="outline" class="d-block">
            <mat-label>Start date</mat-label>
            <input
              matInput
              [matDatepicker]="picker_start"
              data-test="filters-date-min"
              [value]="peblFilters.startDate"
              (dateChange)="startDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker_start"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #picker_start
                data-test="date-picker-start"
              ></mat-datepicker>
              <mat-error data-test="filters-date-min-error">
                Invalid date
              </mat-error>
            </mat-form-field>

            <mat-form-field color="primary" appearance="outline" class="d-block">
              <mat-label>End date</mat-label>
              <input
                matInput
                [matDatepicker]="picker_end"
                data-test="filters-date-max"
                [value]="peblFilters.endDate"
                (dateChange)="endDateChange($event)"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker_end"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #picker_end
                  data-test="date-picker-end"
                ></mat-datepicker>
                <mat-error data-test="filters-date-max-error">
                  Invalid date
                </mat-error>
              </mat-form-field>

              <mat-form-field class="d-block w-100">
                <mat-label>Link Status</mat-label>
                <mat-select
                  [(value)]="peblFilters.status"
                  class="d-block w-100"
                  (selectionChange)="filterChange()"
                  >
                  <mat-option>All</mat-option>
                  <mat-option value="Sent">Sent</mat-option>
                  <mat-option value="Authorised">Complete</mat-option>
                </mat-select>
              </mat-form-field>

              <button
                mat-stroked-button
                class="bg-white-always mon-border-primary border mon-text-primary"
                data-test="filters-clear-btn"
                (click)="clearFilters()"
                >
                Clear Filters
              </button>
            </div>
        }

        @if (viewMode === 'scheduled') {
        <div class="p-2">
              <p class="mb-1 mon-text-primary">Schedule Status</p>
              <mat-radio-group
                color="primary"
                [value]="scheduleStatusFilter"
                (change)="scheduleStatusFilter = $event.value"
                class="d-flex flex-column mb-2"
                data-test="filters-schedule-status"
                >
                <mat-radio-button [value]="undefined">All</mat-radio-button>
                @for (scheduleStatus of scheduleStatuses; track scheduleStatus) {
                  <mat-radio-button
                    [value]="scheduleStatus"
                    >{{ scheduleStatus }}</mat-radio-button
                  >
                }
              </mat-radio-group>
        </div>
        }
          </div>
        </div>
      </mat-drawer>
      <mat-drawer-content
        class="ml-0 bg-panel page-height d-flex justify-content-between align-items-center flex-column p-md-2"
        >
        <!-- Transaction list header -->
        <mat-divider></mat-divider>
        <div
          class="d-flex justify-content-between align-items-center flex-row py-3 px-4 w-100 list-toolbar main-panel rounded-top"
          style="z-index: 10"
          >
          <button
            mat-icon-button
            class="bg-white-always mon-border-primary border mon-text-primary d-flex align-items-center justify-content-center"
            (click)="Refresh()"
            data-test="transactions-refresh-btn"
            >
            <mat-icon>refresh</mat-icon>
          </button>

          <mat-button-toggle-group
            class="ms-3"
            [value]="viewMode"
            (change)="onViewModeChange($event.value)"
            data-test="pebl-tracking-view-mode"
            >
            <mat-button-toggle value="links">Links</mat-button-toggle>
            <mat-button-toggle value="scheduled">Scheduled</mat-button-toggle>
          </mat-button-toggle-group>

          <div class="flex-fill"></div>

          <button
            class=""
            mat-icon-button
            class="bg-white-always mon-border-primary border mon-text-primary d-flex align-items-center justify-content-center"
            (click)="drawer.open()"
            [disabled]="!tabletQuery.matches"
            data-test="transactions-filters-btn"
            >
            <mat-icon>filter_alt</mat-icon>
          </button>
        </div>

        @if (viewMode === 'scheduled') {
        <div class="w-100 h-100 flex-fill">
          <odin-pebl-scheduled-list
            [statusFilter]="scheduleStatusFilter"
          ></odin-pebl-scheduled-list>
        </div>
        }

        @if (viewMode === 'links') {
        <div class="w-100 h-100 flex-fill d-flex flex-column">
          <!-- Column headers (md and up only) -->
          <div class="main-panel pebl-grid pebl-grid--links pebl-header">
            <span class="pebl-h-name">Name</span>
            <span class="pebl-h-date">Created</span>
            <span class="pebl-h-ref">Reference</span>
            <span class="pebl-h-amount">Amount</span>
            <span class="pebl-h-status">Status</span>
          </div>

          @if (showSkeleton) {
            <div
              class="pebl-viewport pebl-skeleton"
              data-test="pebl-links-skeleton"
            >
              @for (row of skeletonRows; track row) {
                <div class="main-panel pebl-grid pebl-grid--links pebl-grid-row">
                  <div class="pebl-cell pebl-c-lead">
                    <span class="pebl-skel"></span>
                  </div>
                  <div class="pebl-cell pebl-c-expiry">
                    <span class="pebl-skel pebl-skel-line"></span>
                  </div>
                  <div class="pebl-cell pebl-c-name">
                    <span class="pebl-skel pebl-skel-line"></span>
                    <span class="pebl-skel pebl-skel-line pebl-skel-sub"></span>
                  </div>
                  <span class="pebl-cell pebl-c-date">
                    <span class="pebl-skel pebl-skel-line"></span>
                  </span>
                  <span class="pebl-cell pebl-c-ref">
                    <span class="pebl-skel pebl-skel-line"></span>
                  </span>
                  <span class="pebl-cell pebl-c-amount">
                    <span class="pebl-skel pebl-skel-line"></span>
                  </span>
                  <div class="pebl-cell pebl-c-status">
                    <span class="pebl-skel pebl-skel-status"></span>
                  </div>
                </div>
                <mat-divider></mat-divider>
              }
            </div>
          } @else {
          <!-- main-panel: the viewport paints the same background as its rows.
               On a hard scroll the compositor can reveal a strip before the CDK
               has rendered rows for it, and without this the darker bg-panel
               behind the list shows through as a grey flicker. -->
          <cdk-virtual-scroll-viewport
            [itemSize]="rowSize"
            [minBufferPx]="minBufferPx"
            [maxBufferPx]="maxBufferPx"
            class="pebl-viewport main-panel"
          >
            <div *cdkVirtualFor="let trackedLink of trackingLinks; let i = index">
              <div
                class="interactive main-panel pebl-grid pebl-grid--links pebl-grid-row"
                (click)="OpenDetails(trackedLink)"
                (keydown.enter)="OpenDetails(trackedLink)"
                tabindex="0"
                role="button"
                data-test="tx-pebl-tracking-row"
                >
                <!-- Delivery method -->
                <div class="pebl-cell pebl-c-lead">
                  <mat-icon
                    class="outline"
                    [matTooltip]="rowDeliveryTooltip(trackedLink)"
                    matTooltipPosition="right"
                    >{{ rowDeliveryIcon(trackedLink) }}</mat-icon
                    >
                </div>

                <!-- Delivery Status: xl-only detail, superseded on mobile by the status pill below -->
                <div
                  class="pebl-cell pebl-c-expiry"
                  [matTooltip]="
                    (trackedLink.linkExpiration | date: 'd MMM yyyy hh:mm a') || 'N/A'
                  "
                  >
                  <!-- Default icons but don't shown for Authorised or Cancelled -->
                  @if (trackedLink.status !== 'Authorised' && trackedLink.status !== 'Cancelled') {
                    <mat-icon
                      class="me-1 {{ rowDeliveryExpiryClass(trackedLink) }}"
                      >{{ rowDeliveryExpiryIcon(trackedLink) }}</mat-icon
                      >
                  }

                  <!-- Paid icon -->
                  @if (trackedLink.status === 'Authorised') {
                    <mat-icon
                      class="me-1 {{ rowDeliveryExpiryClass(trackedLink) }} outline"
                      >credit_score</mat-icon
                      >
                  }

                  <!-- Cancelled icon -->
                  @if (trackedLink.status === 'Cancelled') {
                    <mat-icon
                      class="me-1 {{ rowDeliveryExpiryClass(trackedLink) }} outline"
                      >cancel</mat-icon
                      >
                  }

                  <!-- Only show status text for an unpaid, still-live link - not once it expires -->
                  @if (
                    trackedLink.status === 'Sent' &&
                    !hasExpired(trackedLink)
                    ) {
                    <span class="d-block">{{
                      trackedLink.linkExpiration | relativeTime | titlecase
                    }}</span>
                  }
                </div>

                <!-- Name (with the created date stacked under it on mobile) -->
                <div class="pebl-cell pebl-c-name">
                  <span
                    class="pebl-name-text"
                    [matTooltip]="trackedLink.name || '-'"
                    >{{ trackedLink.name || '-' }}</span
                    >
                  <span class="pebl-name-sub">{{
                    trackedLink.linkCreated | date: 'dd/MM/yy HH:mm'
                  }}</span>
                </div>

                <!-- Created date (own column from md up) -->
                <div class="pebl-cell pebl-c-date">
                  <span class="pebl-date-day">{{
                    trackedLink.linkCreated | date: 'd MMM y'
                  }}</span>
                  <span class="pebl-date-time"
                    >At {{ trackedLink.linkCreated | date: 'h:mm a' }}</span
                    >
                </div>

                <!-- Reference (md and up) -->
                <span
                  class="pebl-cell pebl-c-ref"
                  [matTooltip]="trackedLink.paymentDetail"
                  >{{ trackedLink.paymentDetail }}</span
                  >

                <span class="pebl-cell pebl-c-amount">{{
                  trackedLink.amount / 100 | currency: trackedLink.currencyCodeIso
                }}</span>

                <!-- Status: a labelled pill from md up, an icon on mobile -->
                <div class="pebl-cell pebl-c-status">
                  <div
                    class="pebl-status-circle {{
                      rowDeliveryPillClass(trackedLink, false)
                    }}"
                    >
                    <mat-icon class="m-0 outline">{{
                      rowDeliveryPillIcon(trackedLink)
                    }}</mat-icon>
                  </div>
                  <div
                    class="pebl-status-pill {{
                      rowDeliveryPillClass(trackedLink, true)
                    }}"
                    >
                    <span class="d-block text-center">{{
                      rowDeliveryPillText(trackedLink)
                    }}</span>
                  </div>
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>

            <div>
              @if (loading) {
                <div class="pebl-row__loading p-2 w-100" style="z-index: 1000">
                  <odin-loading-spinner
                    class="mt-2"
                    [active]="true"
                    [diameter]="40"
                    [colour]="'primary'"
                  ></odin-loading-spinner>
                  <p class="m-0 text-center w-100">Loading...</p>
                </div>
              }
              @if (
                !loading &&
                !moreContent &&
                trackingLinks !== undefined &&
                trackingLinks.length > 0
                ) {
                <div class="odin-list-end" data-test="pebl-links-list-end">
                  <mat-icon class="outline">check_circle</mat-icon>
                  <span>End of links</span>
                </div>
              }
              @if (
                !loading &&
                fetched &&
                trackingLinks !== undefined &&
                trackingLinks.length === 0
                ) {
                <div class="odin-empty-state" data-test="pebl-links-empty">
                  <div class="odin-empty-state-icon">
                    <mat-icon class="outline">link_off</mat-icon>
                  </div>
                  <p class="odin-empty-state-title">No payment links found</p>
                  <p class="odin-empty-state-text">
                    There are no links matching your current filters. Try
                    widening the date range or clearing a filter.
                  </p>
                </div>
              }
            </div>
          </cdk-virtual-scroll-viewport>
          }
        </div>
        }
                  </mat-drawer-content>
                </mat-drawer-container>
